import { useRegionalOverviewStore } from '@features/regional-overview/regional-overview.store';
import type { ReactNode } from 'react';
import styles from './model-view.module.css';

interface Props {
  map: ReactNode;
  list?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  className?: string;
  dataTestId?: string;
}

export const RegionalModelView = ({ map, list, footer, children, className, dataTestId }: Props) => {
  const mobileView = useRegionalOverviewStore(state => state.mobileView);

  const rootClassName = className ? `${styles.root} ${className}` : styles.root;

  return (
    <div className={rootClassName} data-mobile-view={mobileView} data-testid={dataTestId}>
      <div className={styles.map}>{map}</div>
      {list && <div className={styles.list}>{list}</div>}
      {footer}
      {children}
    </div>
  );
};
